const CONTENT_TYPE_PRIORITY = [
    'video/mp4' // MP4
];

function getBestResolutionRendition(playerWidth, renditions) {
    // Sort by height, then width
    const renditionsByResolution = renditions
        .sort((prev, next) => prev.height - next.height || prev.width - next.width);

    // Select best fit
    // Since the video displays in a square, we want to compare the grid width
    // to the videos height to ensure better quality on landscape videos.
    return renditionsByResolution.filter(({height}) => height >= playerWidth)[0]
    || renditionsByResolution[renditionsByResolution.length - 1];
}

export function getOrderedRenditions(playerWidth, renditions) {
    return CONTENT_TYPE_PRIORITY.reduce((acc, type) => {
        const bestRendition = getBestResolutionRendition(
            playerWidth,
            renditions.filter(({content_type}) => content_type === type)
        );
        return bestRendition ? acc.concat([bestRendition]) : acc;
    }, []);
}

export function formatImageUrl(url, width) {
    if (!url) {
        return '';
    }
    if (!width) {
        return url;
    }
    // Round up to the nearest 100px to increase the cache-hit rate
    const roundedWidth = Math.ceil(width / 100) * 100;
    const downsizeParam = `downsize=${roundedWidth}:*`;
    const autoFormatParam = `output-format=auto`;
    return `${url}${url.includes('?') ? '&' : '?'}${downsizeParam}&${autoFormatParam}`;
}
